export default __webpack_public_path__ + "static/media/freewill-banner.504de4b4.jpg";